import { localeTag } from '@/contexts/LanguageContext';

// Montos en USD con el formato del idioma activo ($12.50 · US$ 12,50 · 12,50 $US).
export const fmtMoney = (v) => {
  const n = Number(v || 0);
  try {
    return n.toLocaleString(localeTag(), { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } catch {
    return `$${n.toFixed(2)}`;
  }
};

export const fmtCents = (cents) => fmtMoney(Number(cents || 0) / 100);

// Números (conteos, porcentajes) con separadores del idioma activo.
export const fmtNum = (v, opts) => Number(v || 0).toLocaleString(localeTag(), opts);
